/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AnotherPeriodAliases {
  DATE_PICKER_SCHEDULE_RANGE = 'date-picker-schedule-range',
  LAYOUT_SCHEDULE_PERIOD = 'layout-schedule-period',
  PANEL_SCHEDULE_PERIOD = 'panel-schedule-period',
}
export { AnotherPeriodAliases };
